globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Media = appCustomerSpace.Modals.Media || {};

appCustomerSpace.Modals.Media.AltDescriptionImageContent = (function(superClass) {

  utils.extend(AltDescriptionImageContent, superClass);

  function AltDescriptionImageContent() {
    AltDescriptionImageContent.__super__.constructor.apply(this, arguments);

    this.$input = this.$html.find('.alt-description-input');
    this.$validateBtn = this.$html.find('.validate-alt-btn');

    this.imageContentId = this.$html.data('image-content-id');
    this.stimulusController = this.$html.data('stimulus-controller');
  }

  $.extend(AltDescriptionImageContent.prototype, {
    init: function() {
      this._initEvents();
      return AltDescriptionImageContent.__super__.init.apply(this, arguments);
    },

    _initEvents: function() {
      var modal = this;

      this.$validateBtn.on('click', function() {
        modal._submit();
      });

      this.$input.on('keydown', function(event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          modal._submit();
        }
      });
    },

    _submit: function() {
      var modal = this;
      var csrfToken = $('meta[name="csrf-token"]').attr('content');
      var stimulusController = modal.stimulusController;
      var altValue = modal.$input.val();

      var updateUrl = stimulusController
        ? stimulusController.createUrlValue + '/' + modal.imageContentId
        : '/customer_space/media/image_contents/' + modal.imageContentId;

      modal.close();

      $.ajax({
        url: updateUrl,
        method: 'PATCH',
        dataType: 'json',
        headers: { 'X-CSRF-Token': csrfToken },
        data: {
          alt_description: altValue,
          ai: stimulusController ? stimulusController.isAi : false,
          aspect_ratios: stimulusController ? stimulusController.aspectRatiosValue.join(',') : ''
        },
        success: function(data) {
          if (data.response && stimulusController) {
            stimulusController.handleImageEdited(data.image_content, data.component_body_html);
          }
        },
        error: function() {
          console.error('Error updating alt description');
        }
      });
    }
  });

  return AltDescriptionImageContent;

})(appCustomerSpace.Modal);
